import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from "react-redux";


const SalesChart = ({ SalesAndDealerCountData }) => {
    var monthName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec");
    var d = new Date();
    d.setDate(1);
    var month = [];
    for (var i = 0; i <= 11; i++) {
        month.push(monthName[d.getMonth()] + ' ' + d.getFullYear());
        d.setMonth(d.getMonth() - 1);
    }

    let salesCount = SalesAndDealerCountData[0].OrderCount.split(",");
    let dealerCount = SalesAndDealerCountData[0].DealerCount.split(",");

    const [chartData, setChartData] = useState({
        series: [
            { name: 'Orders', data: salesCount },
            { name: 'Dealers', data: dealerCount },
        ],
        options: {
            chart: {
                height: 350,
                type: 'area',
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth',
            },
            xaxis: {
                categories: month.reverse(),
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm',
                },
            },
            // title: {
            //     text: 'Test',
            //     align: 'left',
            // },
        },
    });

    useEffect(() => {
        // Render the chart when the component mounts
        const domContainer = document.querySelector('#chart');
        const chart = <ReactApexChart options={chartData.options} series={chartData && chartData.series && chartData.series} type="area" height={450} />;
        ReactDOM.render(chart, domContainer);

        // Cleanup on component unmount
        return () => {
            ReactDOM.unmountComponentAtNode(domContainer);
        };
    }, [chartData]);


    return (
        <div>
            <div id="chart"></div>
            <div id="html-dist"></div>
        </div>
    );
};

export default SalesChart;
